interface CustomForkIconProps {
  className?: string;
  fill?: string;
  width?: number;
  height?: number;
}

/** @deprecated Use icons from icons-v2-generated instead. */
export const CustomForkIcon = ({ 
  className, 
  fill = "#888888", 
  width = 24, 
  height = 24,
  ...props 
}: CustomForkIconProps) => (
  <svg 
    width={width} 
    height={height} 
    viewBox="0 0 24 24" 
    fill="none" 
    xmlns="http://www.w3.org/2000/svg" 
    className={className}
    {...props}
  >
    <path 
      d="M10.8745 15.9995V13.1255H8.5C6.22199 13.1255 4.37526 11.2784 4.375 9.00049V8C4.375 7.37868 4.87868 6.875 5.5 6.875C6.12132 6.875 6.625 7.37868 6.625 8V9.00049C6.62526 10.0358 7.46463 10.8755 8.5 10.8755H15.5005C16.5356 10.8752 17.3752 10.0356 17.3755 9.00049V8C17.3755 7.37868 17.8792 6.875 18.5005 6.875C19.1216 6.87526 19.6255 7.37884 19.6255 8V9.00049C19.6252 11.2783 17.7783 13.1252 15.5005 13.1255H13.1245V15.9995C13.1245 16.6208 12.6208 17.1245 11.9995 17.1245C11.3784 17.1242 10.8745 16.6207 10.8745 15.9995Z" 
      fill={fill} 
    />
    <path 
      d="M13.3755 18.4995C13.3752 17.7403 12.7592 17.1255 12 17.1255C11.2408 17.1255 10.6248 17.7403 10.6245 18.4995C10.6245 19.2589 11.2406 19.875 12 19.875C12.7594 19.875 13.3755 19.2589 13.3755 18.4995ZM6.87451 5.50049C6.87451 4.74126 6.25966 4.12526 5.50049 4.125C4.7411 4.125 4.125 4.7411 4.125 5.50049C4.12526 6.25966 4.74077 6.875 5.5 6.875C6.259 6.87474 6.87425 6.25949 6.87451 5.50049ZM19.875 5.50049C19.875 4.7411 19.2589 4.125 18.4995 4.125C17.7403 4.12526 17.1255 4.74126 17.1255 5.50049C17.1258 6.25949 17.7405 6.87425 18.4995 6.87451C19.2587 6.87451 19.8747 6.25966 19.875 5.50049ZM15.6255 18.4995C15.6255 20.5015 14.002 22.125 12 22.125C9.99797 22.125 8.37451 20.5015 8.37451 18.4995C8.37478 16.4977 9.99813 14.8755 12 14.8755C14.0019 14.8755 15.6252 16.4977 15.6255 18.4995ZM9.12451 5.50049C9.12425 7.50213 7.50213 9.12425 5.50049 9.12451C3.49862 9.12451 1.87526 7.5023 1.875 5.50049C1.875 3.49846 3.49846 1.875 5.50049 1.875C7.5023 1.87526 9.12451 3.49862 9.12451 5.50049ZM22.125 5.50049C22.1247 7.5023 20.5014 9.12451 18.4995 9.12451C16.4979 9.12425 14.8758 7.50213 14.8755 5.50049C14.8755 3.49862 16.4977 1.87526 18.4995 1.875C20.5015 1.875 22.125 3.49846 22.125 5.50049Z" 
      fill={fill} 
    />
  </svg>
) 